export default "__VITE_ASSET__BNq4tUuR__"